import { rest } from 'msw'

import { type RequestableApproverApiModel } from '@webapp/platform/approval-routing/data-access/api-models/RequestableApproverApiModel'
import { RequestableApproverApiModelStub } from '@webapp/platform/approval-routing/data-access/api-models/stubs/RequestableApproverApiModel.stub'
import { getResponseObject } from '@webapp/tests'

export const mockGetRequestableApproversSuccess = (
  data: RequestableApproverApiModel[] = RequestableApproverApiModelStub.buildList(
    2
  ),
  pagination = {},
  metadata = {}
) => {
  return rest.post('/api/v3/approvers/requestable/', (_, res, ctx) => {
    return res.once(
      ctx.status(200),
      ctx.json(getResponseObject(data, pagination, metadata))
    )
  })
}

export const mockGetRequestableApproversError = () => {
  return rest.post('/api/v3/approvers/requestable/', (_, res, ctx) => {
    return res.once(ctx.status(401))
  })
}
